import axios from './axiosInstance';

const BASE = process.env.REACT_APP_ALI_URL || 'https://api.mazesai.com/aliapi/';

export const searchGeneralProducts = async (keyWord = '', categoryId = '', pageIndex = 1) => {
  const payload = {
    pageIndex: String(pageIndex),
  };

  let endpoint = '';

  if (categoryId && !keyWord.trim()) {
    // Only category selected, use category-specific search
    payload.categoryId = categoryId;
    endpoint = `${BASE}products/by-category/`;
  } else {
    // Keyword search (with or without category)
    payload.keyWord = keyWord.trim() || 'electronics';
    if (categoryId) payload.categoryId = categoryId;
    endpoint = `${BASE}products/search-general/`;
  }

  try {
    const res = await axios.post(endpoint, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return res.data;
  } catch (error) {
    console.error('Error fetching products:', error);
    return {};
  }
};

export async function getCategoryHierarchy() {
  const res = await fetch(`${BASE}categories/hierarchy/`);
  return res.json();
}

export async function getProductDetail(productId) {
  const res = await fetch(`${BASE}products/${productId}/`);
  return res.json();
}

export async function getShipping(productId, sku_id, ship_to = 'NG') {
  const res = await fetch(
    `${BASE}products/${productId}/shipping/?sku_id=${sku_id}&ship_to=${ship_to}`
  );
  return res.json();
}
